import { makeTypeGuardByPropertyValue } from '../../types';
import type { AsnFilterOperator, AsnTableFilter } from './types/asnFilter';
import type {
  BooleanFilterOperator,
  BooleanTableFilter,
} from './types/booleanFilter';
import type {
  DateTimeFilterOperator,
  DateTimeTableFilter,
} from './types/dateTimeFilter';
import type { IpFilterOperator, IpTableFilter } from './types/ipFilter';
import type { Ipv6FilterOperator, Ipv6TableFilter } from './types/ipv6Filter';
import type {
  LabelsFilterOperator,
  LabelsTableFilter,
} from './types/labelsFilter';
import type {
  NumberFilterOperator,
  NumberTableFilter,
} from './types/numberFilter';
import type { ObjectFilter, ObjectFilterOperator } from './types/objectFilter';
import type {
  RoutingFilterOperator,
  RoutingTableFilter,
} from './types/routingFilter';
import type {
  RoutingIpv6FilterOperator,
  RoutingIpv6TableFilter,
} from './types/routingIpv6Filter';
import type {
  SelectFilterOperator,
  SelectTableFilter,
} from './types/selectFilter';
import type { TextFilterOperator, TextTableFilter } from './types/textFilter';
import type {
  UptimeFilterOperator,
  UptimeTableFilter,
} from './types/uptimeFilter';

export type TableFilter =
  | TextTableFilter
  | SelectTableFilter
  | NumberTableFilter
  | RoutingTableFilter
  | IpTableFilter
  | AsnTableFilter
  | UptimeTableFilter
  | BooleanTableFilter
  | RoutingIpv6TableFilter
  | Ipv6TableFilter
  | ObjectFilter
  | DateTimeTableFilter
  | LabelsTableFilter;

export const isSelectTableFilter = makeTypeGuardByPropertyValue<
  TableFilter,
  SelectTableFilter
>()('type', 'select');
export const isTextTableFilter = makeTypeGuardByPropertyValue<
  TableFilter,
  TextTableFilter
>()('type', 'text');
export const isNumberTableFilter = makeTypeGuardByPropertyValue<
  TableFilter,
  NumberTableFilter
>()('type', 'number');
export const isAsnTableFilter = makeTypeGuardByPropertyValue<
  TableFilter,
  AsnTableFilter
>()('type', 'asn');
export const isBooleanTableFilter = makeTypeGuardByPropertyValue<
  TableFilter,
  BooleanTableFilter
>()('type', 'boolean');
export const isObjectTableFilter = makeTypeGuardByPropertyValue<
  TableFilter,
  ObjectFilter
>()('type', 'object');
export const isDateTimeTableFilter = makeTypeGuardByPropertyValue<
  TableFilter,
  DateTimeTableFilter
>()('type', 'dateTime');
export const isLabelsTableFilter = makeTypeGuardByPropertyValue<
  TableFilter,
  LabelsTableFilter
>()('type', 'labels');
export const isRoutingTableFilter = makeTypeGuardByPropertyValue<
  TableFilter,
  RoutingTableFilter
>()('type', 'routing');
export const isRoutingIpv6TableFilter = makeTypeGuardByPropertyValue<
  TableFilter,
  RoutingIpv6TableFilter
>()('type', 'routingIpv6');
export const isUptimeTableFilter = makeTypeGuardByPropertyValue<
  TableFilter,
  UptimeTableFilter
>()('type', 'uptime');

export type TableFilterOperator =
  | AsnFilterOperator
  | IpFilterOperator
  | NumberFilterOperator
  | RoutingFilterOperator
  | SelectFilterOperator
  | TextFilterOperator
  | UptimeFilterOperator
  | BooleanFilterOperator
  | RoutingIpv6FilterOperator
  | Ipv6FilterOperator
  | ObjectFilterOperator
  | DateTimeFilterOperator
  | LabelsFilterOperator;

export type TableFilterBase = {
  operators: TableFilterOperator[];
  comparableColumns?: string[];
};

export type ObjectFilterChild = {
  field: string;
  filter: TableFilter;
  title: string;
};
